module.exports = __webpack_public_path__ + "img/logo.3f424e02.svg";